import Bus from "@/lib/Bus"
import { IPrj } from "@/prj/IPrj";
import { IWykrojnik } from "@/wykrojniki/IWykrojnik";
import { IErr } from "./IErr";
const bus: Bus = new Bus().getBus();
import { ITree } from "./ITree";
import {ITreeSvc,tree_api} from "./ITreeSvc"
import { IColor } from "../../server/src/tree/mapper/IColor"
import { ILbl } from "@/lbl/ILbl";
import { IOpMapParams } from "server/src/tree/mapper/op/IOpMapParams";
import { IOpEtap, IOpOperacja, IOpParent } from "server/src/tree/mapper/op/IOp";


export class TreeSvc implements ITreeSvc {

    public async assign_prj(tree:ITree, prj: IPrj): Promise<ITree | undefined>  {
        const lbl_ret = await bus.api(tree_api.assign_prj, {tree:tree, prj: prj});
        return lbl_ret;
    }

    public async del_tree(tree: ITree): Promise<ITree | undefined> {
        //console.log(tree._id)
        //console.log(tree.etapy)
        const ret = await bus.call(tree_api.del_tree, tree);
        if (ret) return (<ITree> ret);
        else return undefined
    }

    public async update(tree: ITree): Promise<ITree | undefined> {
        //console.log(tree._id)
        //console.log(tree.etapy)
        const ret = await bus.call(tree_api.update, tree);
        if (ret) return (<ITree> ret);
        else return undefined
    }

    public async import_from_kalk(prj_id:any, kalk_id: any): Promise<ITree | undefined> {
        const ret = await bus.call(tree_api.import_from_kalk, {prj_id:prj_id, kalk_id:kalk_id });
        if (ret) return (<ITree> ret);
        else return undefined
    }
   
    public async fill_and_validate(tree: ITree): Promise<ITree | undefined> {
        const ret = await bus.call(tree_api.fill_and_validate, tree);
        if (ret) return (<ITree> ret);
        else return undefined
    }

    public async find_by_id(_id: any): Promise<ITree | undefined  > {
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",_id)
        if (!_id) throw ("_id is empty");
        const ret = await bus.call(tree_api.find_by_id,{_id:_id});
        if (ret && ret._id) return (<ITree> ret);
        else return undefined
    }

    public async find_prj_by_id(_id:any):Promise<IPrj | undefined > {
        if (!_id) throw ("_id is empty");
        const ret = await bus.call(tree_api.find_by_prj_id, {_id:_id});
        if (ret && ret._id) return (<IPrj> ret);
        else return undefined
    }

    public async copy_full_tree(tree:ITree):Promise<ITree|undefined> {
        const ret = await bus.api(tree_api.copy_full_tree, {tree:tree});
        if (ret) return (<ITree> ret);
        else return undefined
    }

    public async get_selected_wykrojnik_for_tree(_id: any): Promise<IWykrojnik | undefined  > {
        if (!_id) throw ("_id is empty");
        const ret = await bus.call(tree_api.get_selected_wykrojnik_for_tree,{_id:_id});
        if (ret && ret._id) return (<IWykrojnik> ret);
        else return undefined
    }

    public async create_lbl_tree(_id:any, lbl_id:any, lbl_idn:string|undefined): Promise<ITree | undefined> {
       return undefined;
    }

    public async find_by_prj_id(prj_id:any):Promise<ITree | undefined> {
        const ret = await bus.call(tree_api.find_by_id,{prj_id:prj_id});
        if (ret && ret._id) return (<ITree> ret);
        else return undefined
    }

    public async find_trees_short(params:any):Promise<ITree[] | undefined> {
        const ret = await bus.call(tree_api.find_trees_short, params);
        if (ret) return (<ITree[]> ret);
        else return undefined
    }

    
    public async update_tree_from_colors(lbl:ILbl):Promise<ITree|undefined> {
        const ret = await bus.call(tree_api.update_tree_from_colors, {lbl: lbl});
        return ret
    }

    public async map_tree_to_operacje(tree: ITree, parent: IOpParent):Promise<IOpOperacja[]> {
        const ret = await bus.call(tree_api.map_tree_to_operacje, { tree: tree, parent: parent});
        return ret
    }

    public async map_operacje_to_tree(operacje: IOpOperacja[], parent:IOpParent, idn: string, nr: number|undefined, x:number, y:number): Promise<ITree|undefined> {
        const ret = await bus.call(tree_api.map_operacje_to_tree, {operacje:operacje, parent:parent, idn: idn, nr: nr, x:x, y:y});
        return ret
    }

    public async map_colors_to_tree(colors:IColor[],map_params:IOpMapParams):Promise<ITree|undefined>  {
        const ret = await bus.call(tree_api.map_colors_to_tree, {colors:colors, map_params:map_params});
        return ret
    }

    public async ensure_tree_exists(lbl:ILbl):Promise<ITree|undefined> {
        const ret = await bus.call(tree_api.ensure_tree_exists, lbl);
        return ret
    }

    public async get_kkt(colors:IColor[]):Promise<any[]> {
        const ret = await bus.call(tree_api.get_kkt, {colors:colors});
        return ret
    }
}
      
  